import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../../Components/Header/HeaderList";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import {
  IRoleMain,
  MasterPages
} from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const FranchiseList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view, exports } = getPermissions(
    MasterPages.Franchise,
    IRoleMain.Masters
  );
  const [totalCount, setTotalCount] = useState<any>();

  const source = {
    url: "franchises/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/franchise/${row?.id}`);
    } else if (action === "Delete") {
    }
  };

  const columns: IColumns[] = [
    {
      header: "image",
      fieldName: "logoUrl",
      type: "img"
    },
    {
      header: "Name",
      fieldName: "name",
      tooltip: true
    },
    {
      header: "Owner",
      fieldName: "owner",
      tooltip: true
    },

    {
      header: "Location",
      fieldName: "location",
      tooltip: true
    },

    {
      header: "Contact",
      fieldName: "contactNumber",
      tooltip: true
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/franchise");
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    return data;
  };
  return (
    <>
      <HeaderList
        title="Franchisees"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="serviceGrid"
              title="Franchisees"
              columns={columns}
              headerType="HaderTopCornered"
              source={source}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              transFormData={transFormData}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
});
